import React, { useEffect, useState } from 'react'

import { IImmigrant } from '../../../types/information';
import useGetInformation from '../../../hooks/user/useGetInformation';

import DataTable from '../../reusables/DataTable';
import { ColDef } from '@ag-grid-community/core';

interface IInformationProps {
    applicantId: number;
}

export interface IInfoListsProps {
    [name: string]: boolean;
};

const infoLists = { immigrant: true, language: true, education: true, experience: true, relative: true }

const Information = ({ applicantId }: IInformationProps) => {

    const [user, setUser] = useState<IImmigrant | null>(null);
    const [accordion, setAccordion] = useState<IInfoListsProps>(infoLists);

    const { data: userData, isPending, isError } = useGetInformation(applicantId);

    useEffect(() => {
        setUser(userData ? userData : null);
    }, [userData]); //eslint-disable-line

    const languageColumns: ColDef[] = [
        { field: "language", headerName: "Name" },
        { field: "test", headerName: "Test" },
        { field: "listening", headerName: "Listening" },
        { field: "reading", headerName: "Reading" },
        { field: "speaking", headerName: "Speaking" },
        { field: "writing", headerName: "Writing" },
    ];

    const educationColumns: ColDef[] = [
        { field: "school_name", headerName: "Name" },
        { field: "type", headerName: "Type" },
        { field: "status", headerName: "Status", valueGetter: ({ data }) => data.status ? data.status.charAt(0).toUpperCase() + data.status.slice(1).split('-').join(' ') : 'N/A' },
        { field: "program_start", headerName: "Start" },
        { field: "graduation_date", headerName: "End", valueGetter: ({ data }) => data.graduation_date ? data.graduation_date : 'N/A' },
        { field: "program_duration", headerName: "Duration", valueGetter: ({ data }) => data.program_duration ? data.program_duration : 'N/A' },
        { field: "country", headerName: "Country", valueGetter: ({ data }) => data.country.name },
    ];

    const experienceColumns: ColDef[] = [
        { field: "job_title", headerName: "Title", valueGetter: ({ data }) => data.job_title.job_title },
        { field: "type", headerName: "Type" },
        { field: "status", headerName: "Status" },
        { field: "lmia", headerName: "Lmia" },
        { field: "emp_relationship", headerName: "Relationship" },
        { field: "country", headerName: "Country", valueGetter: ({ data }) => data.country.name },
        { field: "date_start", headerName: "Start" },
        { field: "date_end", headerName: "End" },
    ];

    const relativeColumns: ColDef[] = [
        { field: "relation", headerName: "Relation" },
        { field: "name", headerName: "Name" },
        { field: "canadian_citizenship", headerName: "Canadian Citizenship" },
    ];

    if (isPending) return <div className="imm_consultant__loading"><div className="imm_consultant__process_loader" />Loading...</div>
    if (isError) return <div className="imm_consultant__loading">Informatio Not found</div>

    return (
        <div className='imm_information__main'>

            <div className={accordion["immigrant"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, immigrant: !accordion.immigrant })}>Immigrant</div>
                <div className="imm_information__content">

                    <div className="imm_information__content_row">
                        <div>
                            <p>Is Studying Canada: <span>{user?.is_studying_canada ? "Yes" : "No"}</span></p>
                            <p>Work Permit: <span>{user?.work_permit ? "Yes" : "No"}</span></p>
                            {user?.permit_issued && (<p>Permit Issued: <span>{new Date(user?.permit_issued).toLocaleDateString()}</span></p>)}
                            {user?.permit_expire && (<p>Permit Expire: <span>{new Date(user?.permit_expire).toLocaleDateString()}</span></p>)}
                            {user?.birthday && (<p>Birthday: <span>{new Date(user?.birthday).toLocaleDateString()}</span></p>)}
                            {user?.business_experience_year ? <p>Business Experience Year: <span>{user?.business_experience_year}</span></p> : ''}
                            <p>Subscribed: <span>{user?.isSubscribe ? "Yes" : "No"}</span></p>
                        </div>

                        <div>
                            {user?.permit_type && (<p>Permit Type: <span>{user?.permit_type}</span></p>)}
                            <p>Pgwp 1 yr: <span>{user?.pgwp_1_yr ? "Yes" : "No"}</span></p>
                            <p>Pgwp 3 yr: <span>{user?.pgwp_3_yr ? "Yes" : "No"}</span></p>
                            <p>Cert of qual: <span>{user?.cert_of_qual ? "Yes" : "No"}</span></p>
                            <p>Prov Nomination: <span>{user?.prov_nomination ? "Yes" : "No"}</span></p>
                            {user?.net_worth && (<p>Net Worth: <span>{user?.net_worth}</span></p>)}
                        </div>

                        <div>
                            {user?.how_hear_about_us && (<p>How Hear About Us: <span>{user?.how_hear_about_us}</span></p>)}
                            {user?.marital_status && (<p>Marital Status: <span>{user?.marital_status}</span></p>)}
                            <p>Partner Canadian: <span>{user?.partner_canadian ? "Yes" : "No"}</span></p>
                            {user?.partner_status && (<p>Partner Status: <span>{user?.partner_status}</span></p>)}
                            {user?.dependent_children ? <p>Dpendent Children: <span>{user?.dependent_children}</span></p> : ''}
                            {user?.preferred_language && (<p>Preferred Language: <span>{user?.preferred_language}</span></p>)}
                        </div>
                    </div>

                </div>
            </div>

            <div className={accordion["language"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, language: !accordion.language })}>Languages</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={user?.languages ?? []} columns={languageColumns} filter={false} /></div>
                </div>
            </div>

            <div className={accordion["education"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, education: !accordion.education })}>Educations</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={user?.schools ?? []} columns={educationColumns} filter={false} /></div>
                </div>
            </div>

            <div className={accordion["experience"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, experience: !accordion.experience })}>Experiences</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={user?.jobs ?? []} columns={experienceColumns} filter={false} /></div>
                </div>
            </div>

            <div className={accordion["relative"] ? "imm_information__accordion active" : "imm_information__accordion"}>
                <div className="imm_information__header" onClick={() => setAccordion({ ...accordion, relative: !accordion.relative })}>Relatives</div>
                <div className="imm_information__content">
                    <div className="imm_information__data_table"><DataTable data={user?.relatives ?? []} columns={relativeColumns} filter={false} /></div>
                </div>
            </div>

        </div>
    );
}
export default Information;